import * as React from 'react';
import {connect} from 'react-redux';
import {WithStyles, withStyles, MenuItem, Menu, Divider, ListItemIcon, Checkbox, Dialog, DialogTitle, IconButton, DialogActions,} from '@material-ui/core';
import Button from '@components/common/button/Button';
import CommonIconButton from '@components/common/iconButton/iconButton.component';
import TranslateNew from '@translate/TranslateNew';
import { HeaderStyle } from './Header.style';
import { ISuggestion } from '@app-types/websocket/suggestion.types';
import ArrowRightIcon from "@material-ui/icons/ArrowRight";
import * as UserActions from '@services/user/user.actions';
import SchedulesMenu from './SchedulesMenu';
import ActivityMenu from './ActivityMenu';
import ImportOtherCalendarMenu from './ImportOtherCalendarMenu';
import Guide from '@components/guide/guide.component';
import ImportEvents from '@components/calendar-export/import.calendar';
import { DialogTop } from '@components/economy/DialogComponens';
import CloseIcon from "@material-ui/icons/Close";
import { ISchedule, IScheduleName } from '@app-types/websocket/schedule.types';
import SCHEDULE_TYPES from '@constants/scheduleTypes';
import * as ScheduleActions from '@services/schedule/schedule.action';
import * as EventActions from '@services/events/event.action';
import { AI_TASK_TYPE, IAiTask } from '@app-types/websocket/event.types';
import HolidaysSettings from '../holidays/HolidaysSettings';
import ExternalCalendarDialog from '../externalCalendar/ExternalCalendarDialog';
import ExternalCalendarEdit from '../externalCalendar/ExternalCalendarEdit';
import ExportCalendarDialog from '../externalCalendar/ExportCalendarDialog';
import { IFamilyMember } from '@app-types/websocket/family.types';
import { FamilyMemberType } from '@services/family/family.constants';
import { getOnlyWeeksOf } from '@services/user/user.utils';

const tn: TranslateNew = TranslateNew.getInstance();

interface IState {
  historyOpen:boolean;
  importOpen:boolean;
  vacationsOpen:boolean;
  localCalendar: string[];
  editSuggestionInstead:{scheduleId:number, suggestionId:number};
  changenameScheduleId:number;
  changeName:string;
  createNewSchedule:boolean;
  confirmCreateAnotherSchedule:boolean;
  showImportUrlDialog:boolean;
  showImportedCalendars:boolean;
  showImportLocalDialog:boolean;
  showExportDialog:boolean;
  showCalendarView:boolean;
}

interface IProps extends WithStyles<typeof HeaderStyle> {
  // selectedDays:IDateRange[];
  suggestions:ISuggestion[];
  

  isEditing:boolean;
  reference:React.RefObject<HTMLButtonElement>;
  open:boolean;
  setSelectedDate: (year:number,month:number,date:number) => void;
  close:() => void;
  
  setMonthSize:(size:"small"|"medium"|"large") => void;
  monthSize:"small"|"medium"|"large";
  startEditing:(scheduleId:number, suggestionId:number|undefined) => void;
  makeNewSuggestionGuide:(scheduleId:number) => void;
  changeScheduleName: (changeName:IScheduleName) => void;
  showDetails:(suggestion:ISuggestion) => void;
  // selectRange: (startOfStartday:number, endOfEndDay:number, days:boolean[]) => void;
  totalSentSuggestionsNonActive:number;
  totalReceivedSuggestionsNonActive:number;
  usedByErrorSchedules:number[];

  totalReceivedSuggestions:number;
  totalSentSuggestions:number;

  showWeekNumber:boolean;
  setShowWeekNum : (show:boolean) => void;
  userId:number;
  family:IFamilyMember[];
  hasSchedule:boolean;
  onlyWeeksOf:number|undefined;
  setOnlyWeeksOf : (parentId:number) => void;
  showActivitiesInEditMode : boolean;
  setShowActivitiesInEditMode : (show:boolean) => void;
  setShowSchoolHolidays : (show:boolean) => void;
  aiTask: (task:IAiTask) => void;
  isTogether:boolean;
}

class MainMenu extends React.Component<IProps, IState> {
  private importRef:React.RefObject<HTMLDivElement>=React.createRef();
  private viewRef:React.RefObject<HTMLDivElement>=React.createRef();
  private vacationsRef:React.RefObject<HTMLDivElement>=React.createRef();

  constructor(props: IProps) {
    super(props);

    this.state = {
      historyOpen:false,
      importOpen:false,
      vacationsOpen:false,
      localCalendar:[],

      editSuggestionInstead:{scheduleId:0, suggestionId:0},
      changenameScheduleId:0,
      changeName:"",
      createNewSchedule:false,
      confirmCreateAnotherSchedule:false,
      showImportUrlDialog:false,
      showImportedCalendars:false,
      showImportLocalDialog:false,
      showExportDialog:false,
      showCalendarView:false,
    };

  }

  public render() {
    const {classes, isEditing} = this.props;

    return (<>
      <ExternalCalendarEdit
        open={this.state.showImportUrlDialog}
        close={() => { this.setState({ showImportUrlDialog: false }); } } 
        editCalendarId={"NEW"}      />
      
      <ExternalCalendarDialog 
        open={this.state.showImportedCalendars} 
        close={() => {this.setState({ showImportedCalendars: false })}}
      />

      <ExportCalendarDialog 
        open={this.state.showExportDialog} 
        close={() => {this.setState({ showExportDialog: false })}}
      />

      <Menu
        anchorEl={this.viewRef.current}
        open={this.state.showCalendarView}
        onClose={() => this.setState({showCalendarView:false})}
      >
        <MenuItem key={"weekoption"}
          onClick={() => {this.props.setMonthSize("small"); this.setState({showCalendarView:false}); 
          this.props.close();}}
        >
          <ListItemIcon>
            <Checkbox 
              color="primary" 
              id="weekcheckbox" 
              checked={this.props.monthSize === 'small'} 
              readOnly={true} 
              edge="start"/>
          </ListItemIcon>   
          <div className={this.props.classes.menuItemTitle}>
            {tn.lang.weekLabel}
          </div>
        </MenuItem>
        <MenuItem key={"splitoption"}
          onClick={() => {this.props.setMonthSize("medium"); this.setState({showCalendarView:false});  
          this.props.close();}}
        >
          <ListItemIcon>
            <Checkbox 
              color="primary" 
              id="splitcheckbox" 
              checked={this.props.monthSize === 'medium'} 
              readOnly={true} 
              edge="start"/>
          </ListItemIcon>   
          <div className={this.props.classes.menuItemTitle}>
            {tn.lang.split}
          </div>
        </MenuItem>        
        <MenuItem key={"monthoption"}
          onClick={() => {this.props.setMonthSize("large");  this.setState({showCalendarView:false}); 
          this.props.close();}}
        >
          <ListItemIcon>
            <Checkbox 
              color="primary" 
              id="monthcheckbox" 
              checked={this.props.monthSize === 'large'} 
              readOnly={true} 
              edge="start"/>
          </ListItemIcon>   
          <div className={this.props.classes.menuItemTitle}>
            {tn.lang.month}
          </div>
        </MenuItem>
      </Menu>

      <Menu
        anchorEl={this.vacationsRef.current}
        open={this.state.vacationsOpen && !isEditing}
        anchorReference="anchorEl"
        onClose={() => this.setState({vacationsOpen:false})}
        transformOrigin={{vertical: 'top', horizontal: 'center'}}
        classes={{
          paper: `${classes.menuPaper} ${classes.vacationsMenuPaper}`,
          list: classes.menuList,
        }}
      >
        <MenuItem
          className={classes.menuListItem}
          onClick={() => {
            this.props.setShowSchoolHolidays(true);
            this.setState({vacationsOpen:false});
            this.props.close();
          }}
        >
          <div className={classes.menuItemTitle}>{tn.lang.import}</div>
        </MenuItem>
        <MenuItem
          className={classes.menuListItem}
          onClick={() => this.clearSchoolHolidays()}
        >
          <div className={classes.menuItemTitle}>{tn.lang.clear}</div>
        </MenuItem>
      </Menu>

      <Dialog
        open={ this.state.showImportLocalDialog }
        onClose={() => this.setState({ showImportLocalDialog:false })}
        classes={{paper:classes.renamePaper}}
      >
        <DialogTop>
          <DialogTitle>{tn.lang.showLocalCal}</DialogTitle>
        </DialogTop>
        <div style={{padding: '0px 24px 8px 24px', display: 'flex', flexDirection: 'column'}}>
          <ImportEvents />
        </div>
        <DialogActions>
          <div>
          <Button  variant='contained' classes={{contained:classes.buttonContained}} color="primary"
            onClick={() => {this.setState({ showImportLocalDialog:false});}}>
              {tn.lang.OK}
          </Button>
          </div>
        </DialogActions>
      </Dialog>


      <Menu
        anchorEl={this.props.reference.current}
        open={this.props.open}
        anchorReference="anchorEl"
        onClose={() => this.props.close()}
        transformOrigin={{vertical: 'top', horizontal: 'right'}}
        classes={{
          paper: classes.menuPaper,
          list: classes.menuList,
        }}
      >

        {/* show week num */}
        <MenuItem
          className={classes.menuListItem}
          onClick={() => this.props.setShowWeekNum(!this.props.showWeekNumber)}>  
          <ListItemIcon>
            <Checkbox color="primary" id="showweek" checked={this.props.showWeekNumber} readOnly={true} edge="start"/>
          </ListItemIcon>        
          
          <div className={classes.menuItemTitle}>
            {tn.lang.scheduleShowWeeks}
          </div>
        </MenuItem>

        {/* show only my weeks, or for an important adult one of the parents' weeks */}
        {(!isEditing && !this.props.isTogether) && this.onlyWeeksChoices().map((choice) => <MenuItem
          key={choice.parentId}
          className={classes.menuListItem}
          onClick={() => this.props.setOnlyWeeksOf(this.props.onlyWeeksOf === choice.parentId ? 0 : choice.parentId)}>
          <ListItemIcon>
            <Checkbox color="primary" id={"onlyweeks" + choice.parentId} checked={this.props.onlyWeeksOf === choice.parentId} readOnly={true} edge="start"/>
          </ListItemIcon>        
          
          <div className={classes.menuItemTitle}>
            {choice.title}
          </div>
        </MenuItem>)}

        {/* show activities when editing */}
        {(isEditing) && <MenuItem
          className={classes.menuListItem}
          onClick={() => this.props.setShowActivitiesInEditMode(!this.props.showActivitiesInEditMode)}>  
          <ListItemIcon>
            <Checkbox color="primary" id="showActi" checked={this.props.showActivitiesInEditMode} readOnly={true} edge="start"/>
          </ListItemIcon>        
          
          <div className={classes.menuItemTitle}>
            {tn.lang.scheduleShowActivities}
          </div>
        </MenuItem>}

        {/* import external calendars */}
        <MenuItem     
          disabled={isEditing}     
          className={classes.menuListItem}
          onClick={() => this.setState({showCalendarView:!this.state.showCalendarView})}>              
          <div className={classes.menuItemTitle}>
            {tn.lang.calendarLayout}
          </div>
          <div className={classes.menuItemEnd} ref={this.viewRef}>
            <ArrowRightIcon />
          </div>
        </MenuItem>

        <Divider />

        {/** the vv-calendars */}
        {(!this.props.isTogether) && <SchedulesMenu 
          isEditing={this.props.isEditing}
          close={() => { this.props.close();}}
          startEditing={(scheduleId:number,suggestionId:number) => this.props.startEditing(scheduleId,suggestionId)}
          startGuide={(scheduleId:number) => this.props.makeNewSuggestionGuide(scheduleId)}
          totalSentSuggestionsNonActive={this.props.totalSentSuggestionsNonActive}
          totalReceivedSuggestionsNonActive={this.props.totalReceivedSuggestionsNonActive}
          usedByErrorSchedules={this.props.usedByErrorSchedules}
          suggestEditing={(sid:number, sug:number) => this.setState({editSuggestionInstead:{scheduleId:sid, suggestionId:sug}})}
          changeName={(sid:number, name:string) => this.setState({ changenameScheduleId:sid, changeName:name})}
          createNewSchedule={() => this.props.hasSchedule
            ? this.setState({confirmCreateAnotherSchedule:true}) // most likely they want to edit the existing schedule, warn first
            : this.setState({createNewSchedule:true})}
          showDetails={(suggestion) => this.props.showDetails(suggestion)}
        />}
        {/** holidays settings */}
        <HolidaysSettings close={() => this.props.close()} disabled={isEditing}/>

        {/* import external calendars */}
        <MenuItem     
          disabled={isEditing}     
          className={classes.menuListItem}
          onClick={() => this.setState({importOpen:!this.state.importOpen})}>              
          <div className={classes.menuItemTitle}>
            {tn.lang.importExportCal}
          </div>
          <div className={classes.menuItemEnd} ref={this.importRef}>
            <ArrowRightIcon />
          </div>
        </MenuItem>

        {/** School vacation settings */}
        <MenuItem
          disabled={isEditing}
          className={classes.menuListItem}
          onClick={() => this.setState({vacationsOpen:!this.state.vacationsOpen})}
        >
          <div className={classes.menuItemTitle}>{tn.lang.labelSchoolBreaks}</div>
          <div className={classes.menuItemEnd} ref={this.vacationsRef}>
            <ArrowRightIcon />
          </div>
        </MenuItem>

        <Divider />

        {/* past activity */}
        <MenuItem
          disabled={isEditing}
          className={classes.menuListItem}
          onClick={() => {this.setState({historyOpen:!this.state.historyOpen}); this.props.close();}}>  

          <div className={classes.menuItemTitle}>
            {tn.lang.calActivity}
          </div>
        </MenuItem>


      </Menu>

      <ImportOtherCalendarMenu
        showExternalCalendarSettings={() => {this.setState({showImportedCalendars:true}); this.props.close()}}
        showExternalCalendarImport={() => {this.setState({showImportUrlDialog:true}); this.props.close()}}
        showLocalImport={() => {this.setState({showImportLocalDialog:true}); this.props.close()}}
        showExport={() => {this.setState({showExportDialog:true}); this.props.close()}}
        open={this.state.importOpen}
        close={() => {this.setState({importOpen:false})}}
        reference={this.importRef}
      />
      
      <Dialog
        open={ this.state.changenameScheduleId !== 0}
        onClose={() => this.setState({ changenameScheduleId:0, changeName:""})}
        classes={{paper:classes.renamePaper}}
      >
        <DialogTop>
          <DialogTitle>{tn.lang.renameSchedule}</DialogTitle>
          <IconButton onClick={() => this.setState({ changenameScheduleId:0, changeName:""})}>
            <CloseIcon />
          </IconButton>
        </DialogTop>
        <div style={{padding: '8px 24px', display: 'flex', flexDirection: 'column'}}>
          <input
            type="text"
            value={this.state.changeName}
            onChange={(event) => this.setState({changeName:event.target.value})}
            autoCorrect="on"
            name="renameinput"
            spellCheck={true}
            autoComplete="off"
            maxLength={25}
            className={classes.textInputLine}
            placeholder={tn.lang.scheduleNamePlaceholder}
          />
        </div>
        <DialogActions>
          <Button  variant='outlined' classes={{outlined:classes.buttonOutlined}} 
            onClick={() => this.setState({ changenameScheduleId:0, changeName:""})} >
              {tn.lang.cancel}
          </Button>
          <Button  variant='contained' classes={{contained:classes.buttonContained}} disabled={this.state.changeName.length === 0} color="primary"
            onClick={() => {this.props.changeScheduleName({name: this.state.changeName, scheduleId: this.state.changenameScheduleId});
              this.setState({ changenameScheduleId:0, changeName:""});}}>
              {tn.lang.save}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={this.state.confirmCreateAnotherSchedule}
        onClose={() => this.setState({confirmCreateAnotherSchedule:false})}
      >
        <DialogTop>
          <DialogTitle>{tn.lang.calMakeNewWarningTitle}</DialogTitle>
          <CommonIconButton onClick={() => this.setState({confirmCreateAnotherSchedule:false})}>
            <CloseIcon />
          </CommonIconButton>
        </DialogTop>
        <div style={{padding: '8px 24px', display: 'flex', flexDirection: 'column'}}>
          {tn.lang.calMakeNewWarning}
        </div>
        <DialogActions>
          <Button variant='outlined' classes={{outlined:classes.buttonOutlined}}
            onClick={() => this.setState({confirmCreateAnotherSchedule:false, createNewSchedule:true})}>
              {tn.lang.calMakeNewWarningContinue}
          </Button>
          <Button variant='contained' classes={{contained:classes.buttonContained}} color="primary"
            onClick={() => this.setState({confirmCreateAnotherSchedule:false})}>
              {tn.lang.cancel}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={ this.state.createNewSchedule}
        onClose={() => this.setState({ createNewSchedule:false})}
        classes={{paper:classes.fullscreenPaper}}
      >
        <div className={classes.background}>
          <div className={classes.circle}/>
        </div>
        <Guide
          style={{zIndex:1}}
          isOnboarding={false}
          firstSchedule={false}
          completedCallback={() => this.setState({ createNewSchedule:false})}
          abortCallback={(event) => {this.setState({ createNewSchedule:false}); event.stopPropagation();}}
        />
      </Dialog>

      <Dialog
        open={ this.state.editSuggestionInstead.scheduleId !== 0}
        onClose={() => this.setState({ editSuggestionInstead:{scheduleId:0,suggestionId:0}})}
      >
        <DialogTop>
          <DialogTitle>{tn.lang.calConfirmReply}</DialogTitle>
          <IconButton onClick={() => this.setState({ editSuggestionInstead:{scheduleId:0,suggestionId:0}})}>
            <CloseIcon />
          </IconButton>
        </DialogTop>
        <div style={{padding: '8px 24px', display: 'flex', flexDirection: 'column'}}>
          {tn.lang.calConfirmNew}
        </div>
        <DialogActions>
          <Button  variant='outlined' classes={{outlined:classes.buttonOutlined}} onClick={() => {
              this.props.startEditing(this.state.editSuggestionInstead.scheduleId, 0);
              this.setState({ editSuggestionInstead:{scheduleId:0,suggestionId:0}});
            }} >
              {tn.lang.calConfirmNewMakeNew}
          </Button>
          <Button  variant='contained' classes={{contained:classes.buttonContained}} color='primary' onClick={() => {
              this.props.startEditing(this.state.editSuggestionInstead.scheduleId, this.state.editSuggestionInstead.suggestionId);
              this.setState({ editSuggestionInstead:{scheduleId:0,suggestionId:0}});
            }}>
              {tn.lang.calConfirmNewEditExisting}
          </Button>
        </DialogActions>
      </Dialog>

      <ActivityMenu      
        open={this.state.historyOpen}
        setSelectedDate={this.props.setSelectedDate}
        close={() => {this.setState({historyOpen:false})}}
      />
      </>
    );
  }

  private onlyWeeksChoices = ():Array<{parentId:number, title:string}> => {
    const me = this.props.family.find((mem) => mem.id === this.props.userId);
    if (me?.role === FamilyMemberType.PARENT) {
      return [{parentId:me.id, title:tn.lang.scheduleShowOnlyMyWeeks}];
    }
    if (me?.role === FamilyMemberType.VIEWER) {
      return this.props.family
        .filter((mem) => mem.role === FamilyMemberType.PARENT)
        .map((parent) => ({parentId:parent.id, title:tn.lang.scheduleShowOnlyWeeksOf(parent.firstName)}));
    }
    return [];
  };

  private clearSchoolHolidays = ()  => {
    const clearTask:IAiTask = {
      language:tn.getLanguage()?tn.getLanguage():"EN",
      promptOne:"none",
      promptTwo:"none",
      promptThree:"us",
      taskType:AI_TASK_TYPE.SCHOOL_VACATIONS,
    };

    this.props.aiTask(clearTask);
    this.setState({vacationsOpen:false});
    this.props.close();
  };

}



function mapStateToProps(state: any) {
  const suggestions:ISuggestion[] = state.suggestion.suggestions?state.suggestion.suggestions:[];
  const showActivitiesInEditMode:boolean = state.user.showActivitiesInEditMode?true:false;

  return {
    suggestions,
    userId: state.user.session.data.id,
    family: state.family.family ? state.family.family : [],
    hasSchedule: (state.schedule.schedules as ISchedule[]).some(
      (sched) => sched.status !== SCHEDULE_TYPES.DELETED && sched.status !== SCHEDULE_TYPES.DELETED_WIP),
    onlyWeeksOf: getOnlyWeeksOf(state),
    showActivitiesInEditMode,
  };
}

const mapDispatchToProps = {
  setShowWeekNum: UserActions.setShowWeekNum,
  setOnlyWeeksOf: UserActions.setOnlyWeeksOf,
  setShowActivitiesInEditMode: UserActions.setShowActivitiesInEditMode,
  changeScheduleName:ScheduleActions.changeScheduleName,
  aiTask: EventActions.aiTask,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(HeaderStyle)(MainMenu));



// WEBPACK FOOTER //
// ./src/components/calendar2/header/MainMenu.tsx